import React, {FC, useEffect, useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import styles from './App.module.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import StepsContainer from '../StepsContainer/StepsContainer';
import {Page, PromotionPhase} from '../../state/types';
import {useState} from '../../state/store';
import PagesContainer from '../PagesContainer/PagesContainer';
import MenuContainer from '../MenuContainer/MenuContainer';
import {config} from '../../state/config';

const PROMOTION_PHASE = PromotionPhase.OnGoing;
// const IS_PROMOTION_END = false;

const promotionPreStartPagesMap: Record<string, Page> = {
    home: Page.Home,
    'how-it-works': Page.HowItWorks,
    'contact-us': Page.ContactUs,
    'qualifying-devices': Page.QualifyingDevices,
    faq: Page.FAQ,
    'terms-and-conditions': Page.TermsAndConditions,
};

const promotionOnGoingPagesMap: Record<string, Page> = {
    home: Page.Home,
    'how-it-works': Page.HowItWorks,
    'contact-us': Page.ContactUs,
    'qualifying-devices': Page.QualifyingDevices,
    faq: Page.FAQ,
    'terms-and-conditions': Page.TermsAndConditions,
    steps: Page.Steps,
};

const promotionEndPagesMap: Record<string, Page> = {
    home: Page.Home,
    'contact-us': Page.ContactUs,
};

const pagesMapByPhase: Record<PromotionPhase, Record<string, Page>> = {
    [PromotionPhase.PreStart]: promotionPreStartPagesMap,
    [PromotionPhase.OnGoing]: promotionOnGoingPagesMap,
    [PromotionPhase.End]: promotionEndPagesMap,
};

const App: FC = () => {
    const {hash} = useLocation();

    const {page, dispatch} = useState('page');
    const [promotionIsActive, setPromotionIsActive] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);

    const hashData = useMemo(() => {
        if (hash !== '') {
            return hash.slice(1);
        }
        return '';
    }, [hash]);

    useEffect(() => {
        const mappedPage = pagesMapByPhase[PROMOTION_PHASE][hashData] || Page.Home;

        dispatch('update', {
            page: mappedPage,
        });
    }, [hashData, dispatch]);

    useEffect(() => {
        localStorage.clear();
        dispatch('recaptchaKey');
        const fetchData = async () => {

            // get the data from the api
            const response = await fetch(`${config.apiUrl}/promotion/status`);
            // convert the data to json
            const json = await response.json();
            let promotion = json.data;

            // set state with the result
            setPromotionIsActive(promotion.is_active);
            setIsLoading(false);

        }

        // call the function
        fetchData()
            // make sure to catch any error
            .catch(console.error);

        if (promotionIsActive) {
            dispatch('vendorsList');
            dispatch('countriesList');
            dispatch('countiesList');
            dispatch('retailersList');
            dispatch('eligibleDevices');
            dispatch('promoDevices');
            dispatch('promoList');
        }
    }, [dispatch, promotionIsActive]);

        return (
            <div className={`${styles.App} flex flex-col justify-between h-screen`} data-testid="App">
                <Header/>
                <div className="container">
                    <MenuContainer isPromotionActive={promotionIsActive}/>
                </div>
                <div className="w-full">
                    {page !== Page.Steps && <PagesContainer isPromotionActive={promotionIsActive} isDisabled={isLoading}/>}
                    {page === Page.Steps && <StepsContainer/>}
                </div>
                <Footer/>
            </div>
        );
};

export default App;